import React, { useState, Suspense, lazy } from "react";
import "./style.scss";
import { Link } from "react-router-dom";
import notify from "../../shared/notify";
import { trackEvent } from "../../shared/analytics";

const Loader = lazy(() => import("../../helper/Loader/loader"));

// import QRcode from "../../asset/images/QR_code.webp";



const Footer = () => {

  const [email, setEmail] = useState();
  const [subscribeBtn, setSubscribeBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubscribebtn = async () => {
    if (!isValidEmail(email)) {
      trackEvent("subscribe_error", { reason: "invalid_email", location: "footer" });
      notify("Please enter a valid email address", "danger");
      return;
    }
    let paylaod = { email: email };
    trackEvent("subscribe_attempt", { location: "footer" });
    setIsLoading(true);
    try {
      const { default: Service } = await import("../../shared/service/service");
      const response = await Service.post1("subscribe", paylaod, (result) => result);
      if (response?.data?.status === "success") {
        trackEvent("subscribe_success", { location: "footer" });
        notify(response?.data?.message || "Subscribed successfully.", "success");
      } else {
        trackEvent("subscribe_error", { reason: "api_error", location: "footer" });
        notify(response?.data?.message || "Subscription failed.", "danger");
      }
    } catch (error) {
      trackEvent("subscribe_error", { reason: "api_error", location: "footer" });
      notify(error?.response?.data?.message || "Subscription failed.", "danger");
    } finally {
      setIsLoading(false);
    }
  };
  const handleErr = () => {
    if (!isValidEmail(email)) {
      trackEvent("subscribe_error", { reason: "invalid_email", location: "footer" });
      notify("Please enter a valid email address", "danger");
      return;
    } else {
      trackEvent("subscribe_error", { reason: "terms_not_accepted", location: "footer" });
      notify("Please accept term and condition ", "danger");
    }
  };

  const handleClick = () => {
    setSubscribeBtn(!subscribeBtn)
  };


  return (
    <div className="footer">
      <div className="BodySection">
        <div className="wrapper">
          <nav id="sidebar" className="sidebar-container">
            {/* <img src={QRcode} className="QRcode"></img> */}
            {/* <p className="para-text1">
                Scan the code to download the app!
              </p>  */}
            <div className="text-box">
              <h6 className="mail-list">JOIN OUR MAILING LIST!</h6>
              <p className="para-text">
                Signup for special updates on event, deals and more!
              </p>
            </div>
            {isLoading && <Suspense fallback={null}><Loader /></Suspense>}
            <div className="email-box">
              <label className="input-box">Email<span className="required-field">:</span></label>
              <input
                className="form-control box"
                type="email"
                placeholder="Enter Email Address"
                autoComplete="off"
                required
                maxLength="100"
                minLength="20"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
            <div className="check-box">
              <input type="checkbox" className={subscribeBtn ? "checkk active" : "checkk"} onClick={handleClick} />
              <span className="checkbox-text">
                I want to receive emails , including game updates and offers ,
                from BlackLight and its affiliates. I can opt out at any time.
                By subscribing , I agree to BlackLight's{" "}
                <Link to="/terms-of-service" className="term-link"> Terms of Service</Link> and <Link to="/privacy-policy" className="term-link"> Privacy Policy</Link>
                .    
              </span>
            </div>

            {subscribeBtn ?
              <button onClick={handleSubscribebtn} className={subscribeBtn ? "subscribe-button active" : "subscribe-button"}>SUBSCRIBE</button>
              : <button onClick={handleErr} className={subscribeBtn ? "subscribe-button active" : "subscribe-button"}>SUBSCRIBE</button>
            }
          </nav>
          <div className="term-policy">
            <span className="term-policy-row">
              <Link to="/terms-of-service" className="term-condition" onClick={() => trackEvent("click_external_link", { link: "terms_of_service" })}>• Terms of Service</Link>
              {" "}
              <Link to="/privacy-policy" className="term-condition" onClick={() => trackEvent("click_external_link", { link: "privacy_policy" })}>• Privacy Policy</Link>
            </span>
            <span className="term-policy-row">
              <Link to="/about-ludo-superstar" className="term-condition">• About</Link>
              {" "}
              <Link to="/contact-ludo-superstar" className="term-condition">• Contact</Link>
              {" "}
              <Link to="/blacklight-studio-games" className="term-condition">• Company</Link>
            </span>
            <h1 className="copyright-text">Copyright © Blacklight Studio Works</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
